import { clsx } from 'clsx'
import { type ComponentProps, type JSX } from 'react'

export const COUNTER_INDICATOR_COLORS = {
  BRAND: 'brand',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
} as const

export type COUNTER_INDICATOR_COLORS =
  (typeof COUNTER_INDICATOR_COLORS)[keyof typeof COUNTER_INDICATOR_COLORS]

export type CounterIndicatorProps = Omit<ComponentProps<'span'>, 'color'> & {
  /**
   * @default primary
   */
  color?: COUNTER_INDICATOR_COLORS

  /**
   * @default s
   */
  // eslint-disable-next-line perfectionist/sort-union-types -- keep semantic order
  size?: 's' | 'm'
}

/**
 * Numbered label
 */
export const CounterIndicator = (props: CounterIndicatorProps): JSX.Element => {
  const { className, color = 'primary', size = 's', ...rest } = props

  return (
    <span
      className={clsx(
        'counter-indicator',
        color === 'brand' && 'counter-indicator_color-brand',
        color === 'primary' && 'counter-indicator_color-primary',
        color === 'secondary' && 'counter-indicator_color-secondary',
        size === 's' && 'counter-indicator_size-s',
        size === 'm' && 'counter-indicator_size-m',
        className,
      )}
      {...rest}
    />
  )
}
